import { Box, CalendarTodayIcon, Flex, ReadonlyField, Text } from '@shared/components';
import { dayjs } from '@shared/utils';

export interface ExamDateReadonlyFieldProps {
  examDate: {
    examStartedAt?: Date;
  };
}

export default function ExamDateReadonlyField(props: Readonly<ExamDateReadonlyFieldProps>) {
  const { examDate } = props;

  return (
    <Box
      sx={{
        maxWidth: '200px',
        width: '100%',
      }}
    >
      <ReadonlyField
        label='วันที่สอบ'
        content={
          <Flex
            sx={{
              gap: (theme) => theme.spacing(1),
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Text>{dayjs(examDate?.examStartedAt).format('DD-MM-YYYY')}</Text>
            <CalendarTodayIcon
              sx={(theme) => ({
                color: theme.palette.text.secondary,
              })}
            />
          </Flex>
        }
      />
    </Box>
  );
}
